import React, { Component } from 'react'
import { Form, Modal, Select, Checkbox } from 'antd'

const FormItem = Form.Item
const Option = Select.Option

class CreateJobForm extends Component {
  handleCreateJobLocal = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.handleCreateJob(values)
      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalVisible, handleToggleCreateJobForm, contractId, contracts } = this.props
    return (
      <Modal
        visible={modalVisible}
        title="Create Job"
        okText={'Create'}
        onCancel={handleToggleCreateJobForm}
        onOk={this.handleCreateJobLocal}
        maskClosable={false}
      >
        <Form layout="vertical">
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Select Contract">
                {getFieldDecorator('contract_id', {
                  initialValue: contractId
                })(
                  <Select>
                    {contracts &&
                      contracts.map(contract => (
                        <Option key={contract.id} value={contract.id}>
                          {contract.id} - {contract.description}
                        </Option>
                      ))}
                  </Select>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Select Job Type">
                {getFieldDecorator('job_type', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select the Job Type'
                    }
                  ]
                })(
                  <Select>
                    <Option value="New Construction">New Construction</Option>
                    <Option value="Modernization">Modernization</Option>
                    <Option value="Maintenance/Service">Maintenance/Service</Option>
                    <Option value="Repair">Repair</Option>
                    <Option value="Specialty">Specialty</Option>
                    <Option value="Material Sale">Material Sale</Option>
                  </Select>
                )}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem>
                {getFieldDecorator('job_without_contract', {})(
                  <Checkbox>Create without contract?</Checkbox>
                )}
              </FormItem>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(CreateJobForm)



// WEBPACK FOOTER //
// ./src/pages/lead/components/CreateJobForm.js